
const FLATPICKR_DATE_LOCALE = {
  weekdays: {
    shorthand: ['일', '월', '화', '수', '목', '금', '토'],
    longhand: ['일', '월', '화', '수', '목', '금', '토']
  },
  months: {
    shorthand: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
    longhand: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
  }
}
const DAY_OF_WEEKS = [
  {
    fullName: "sunday",
    name: "sun",
    label: "일",
  },
  {
    fullName: "monday",
    name: "mon",
    label: "월",
  },
  {
    fullName: "tuesday",
    name: "tue",
    label: "화",
  },
  {
    fullName: "wednesday",
    name: "wed",
    label: "수",
  },
  {
    fullName: "thursday",
    name: "thu",
    label: "목",
  },
  {
    fullName: "friday",
    name: "fri",
    label: "금",
  },
  {
    fullName: "saturday",
    name: "sat",
    label: "토",
  },
];

const CALENDAR_HEADER = [
  {
    label: "일",
    value: "Su",
  },
  {
    label: "월",
    value: "Mo",
  },
  {
    label: "화",
    value: "Tu",
  },
  {
    label: "수",
    value: "We",
  },
  {
    label: "목",
    value: "Th",
  },
  {
    label: "금",
    value: "Fr",
  },
  {
    label: "토",
    value: "Sa",
  },
];

const DAY_OF_WEEKS_NUMBER = [
  {
    label: "월",
    value: 1,
  },
  {
    label: "화",
    value: 2,
  },
  {
    label: "수",
    value: 3,
  },
  {
    label: "목",
    value: 4,
  },
  {
    label: "금",
    value: 5,
  },
  {
    label: "토",
    value: 6,
  },
  {
    label: "일",
    value: 7,
  },
];

const DAY_OF_THE_WEEKS = [
  {
    label: "일",
    value: 0,
  },
  {
    label: "월",
    value: 1,
  },
  {
    label: "화",
    value: 2,
  },
  {
    label: "수",
    value: 3,
  },
  {
    label: "목",
    value: 4,
  },
  {
    label: "금",
    value: 5,
  },
  {
    label: "토",
    value: 6,
  },
];
export { FLATPICKR_DATE_LOCALE, DAY_OF_WEEKS, CALENDAR_HEADER, DAY_OF_WEEKS_NUMBER, DAY_OF_THE_WEEKS };
